import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const deleteInstituteTestPricingMasterApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}test-price`,
        method: "delete",
        data: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })

    return response

}

export default deleteInstituteTestPricingMasterApi